export type SourceCardFallback = 'file_info_failed' | 'mbox_empty' | 'container' | 'no_media';

export type SourceCardFallbackInput = {
  fileInfoLoadError: boolean;
  showUnsupportedMediaMessage: boolean;
  isMboxType: boolean;
  isContainerNonMbox: boolean;
};

/**
 * The one fallback the source card shows once loading ends, or null when media renders.
 * A file-info error wins over "unsupported", matching the render order.
 */
export function resolveSourceCardFallback(input: SourceCardFallbackInput): SourceCardFallback | null {
  if (input.fileInfoLoadError) return 'file_info_failed';
  if (!input.showUnsupportedMediaMessage) return null;
  if (input.isMboxType) return 'mbox_empty';
  if (input.isContainerNonMbox) return 'container';
  return 'no_media';
}

/**
 * Telemetry may fire only after a load that really ran. A load that ended because the session
 * had no cell or token yet looks like a fallback but is not one. This gate never blocks the render.
 */
export function isPreviewTelemetryEligible(input: {
  loadingFileSummary: boolean;
  telemetryReadyKey: string | null;
  sourceLoadKey: string;
}): boolean {
  return !input.loadingFileSummary && input.telemetryReadyKey === input.sourceLoadKey;
}
